var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wr"},[_c('select',{ref:"select"},_vm._l((_vm.items),function(item,i){return _c('option',{key:i,domProps:{"value":item.value}},[_vm._v("\n      "+_vm._s(item.text)+"\n    ")])}))])}
var staticRenderFns = []

export { render, staticRenderFns }